<template>
  <div class="workflow workflow-font-family">
    <div class="workflow-loader" v-if="loading && !shouldRender">
      <div class="progress-icon"></div>
    </div>
    <div class="workflow-loader ai-skill-draft-loader" v-if="isApplyingAISkillDraft">
      <div class="progress-icon"></div>
      <div class="loader-caption">KI-Entwurf wird angewendet...</div>
    </div>
    <template v-if="!loading && shouldRender">
      <WorkFlowHeader
        ref="WorkFlowHeaderRef"
        :process="process"
        :isUserHasAccess="isUserHasAccess"
        :isTableIdArray="isTableIdArray"
        :flowRunnerEndpoint="flowRunnerEndpoint"
        :hasUnsavedChanges="hasUnsavedChanges"
        :socketData="socketData"
        :getFlowAccessLevel="getFlowAccessLevel"
        :setLoader="setLoader"
        @showToaster="showToaster"
        @setRunFlowError="setRunFlowError"
        @setHtmlViewer="setHtmlViewer"
        @setProcess="setProcess"
        @setReferenceProcess="setReferenceProcess"
        @saveZoom="saveZoomToLocalStorage"
        @onSocketDisconnect="onSocketDisconnect"
      />

      <div class="workflow-body">
        <WorkFlowBuilder
          ref="WorkFlowBuilderRef"
          :process="process"
          :tasksArray="getTasksArray"
          :tasksMiscData="getTasksMiscData"
          :isUserHasAccess="isUserHasAccess"
          :flowRunnerEndpoint="flowRunnerEndpoint"
          :isTableIdArray="isTableIdArray"
          :databases="databases"
          :getDatabaseSchema="getDatabaseSchema"
          :customTasksList="getWorkflowCustomTasks"
          :runFlowError="runFlowError"
          :isAdmin="isAdmin"
          :isFloatingTaskBar="isFloatingTaskBar"
          @fetchAndAddSpecificCustomTask="fetchAndAddSpecificCustomTask"
          @showToaster="showToaster"
          @setRunFlowError="setRunFlowError"
          @setProcess="setProcess"
          @onTaskAdd="onTaskAdd"
          @setTaskbarMode="setTaskbarMode"
          @onCustomTaskActionTrigger="onCustomTaskActionTrigger"
          @saveWorkflowFromAISkill="onSaveWorkflowFromAISkill"
        />
        <div
          class="workflow-taskbar-wrapper"
          v-show="!isFlowEmpty && !isFloatingTaskBar"
        >
          <WorkFlowTaskBar
            ref="WorkFlowTaskBarRef"
            :process="process"
            :tasksArray="getTasksArray"
            :tasksMiscData="getTasksMiscData"
            :isUserHasAccess="isUserHasAccess"
            :customTasksList="getWorkflowCustomTasks"
            @onTaskAdd="onTaskAdd"
            @onClose="onCloseTaskBar"
            @setTaskbarMode="setTaskbarMode"
            @onCustomTaskActionTrigger="onCustomTaskActionTrigger"
          />
        </div>
      </div>
      <div v-if="isFlowEmpty" class="empty-workflow-container">
        <div class="init-task-add-button" @click="initiateWorkFlow">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.92871 10H18.9998M10.4642 18.5355V1.46448"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <HtmlViewer
        v-if="htmlViewer.isHtmlViewerVisible"
        :myHtml="htmlViewer.html"
        :myJson="htmlViewer.json"
        @close="hideHtmlViewer()"
      />
      <CustomModal
        class="custom-action-modal"
        @onClose="closeCustomActionModal(true)"
        v-if="customTask.actionType === 'edit'"
      >
        <div>
          <h1>Edit Custom Task</h1>
          <MakeCustomTaskComponent
            :isEditMode="true"
            :task="customTask.task"
            :flowRunnerEndpoint="flowRunnerEndpoint"
            :process="process"
            @closeEditModal="closeEditModal"
            :editCodeDetails="customTask.task.props"
            :inputFields="customTask.task.input"
            @showToaster="showToaster"
          />
        </div>
      </CustomModal>
      <RemoveConfirmModal
        v-if="customTask.actionType === 'delete'"
        class="modal-window"
        name="Eintrag löschen"
        resourceType="item"
        actionType="remove"
        :itemsCount="0"
        :selectedItems="[removeCustomTask]"
        :databaseName="getCustomTaskDatabase[0].name"
        :isLoadingButton="isLoading"
        @close="closeCustomActionModal"
        @confirmRemove="confirmRemoveItem"
      />
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import WorkFlowHeader from '@/components/WorkFlow/WorkFlowHeader.vue';
import WorkFlowTaskBar from '@/components/WorkFlow/WorkFlowTaskBar.vue';
import WorkFlowBuilder from '@/components/WorkFlow/WorkFlowBuilder.vue';
import HtmlViewer from '@/components/modals/htmlViewer.vue';
import {
  workFlowTasksMiscData,
  workFlowAccessLevel,
  workflowCustomTasksList,
} from '@/utils/constants/WorkFlowConstants';
import {
  generateTaskObject,
  generateTaskMiskDataObject,
  getValidatedTasksPosition,
  getWorkflowTasks,
} from '@/utils/helpers/WorkFlowHelpers';

import {
  getWorkFlowById,
  getSharedWorkFlowUsers,
  getDataBaseTableSchema,
  getCustomDatabaseItem,
  getCustomDatabaseItems,
  getUserDataByID,
  deleteDatabaseItem,
} from '@/services/axios/data.api';
import { mapGetters } from 'vuex';
import io from 'socket.io-client';
import CustomModal from '../components/modals/CustomModal.vue';
import MakeCustomTaskComponent from '../components/widgets/MakeCustomTaskComponent.vue';
import RemoveConfirmModal from '../components/modals/removeConfirmModal.vue';

import { getIsVueBasedFormBuilder } from '@/utils/helpers';

export default {
  name: 'WorkFlow',
  data() {
    return {
      loading: false,
      process: null,
      referenceProcess: null,
      flowPermission: {},
      runFlowError: null,
      htmlViewer: {
        isHtmlViewerVisible: false,
        html: null,
        json: null,
      },
      customTasks: [],
      customMiscData: {},
      unsavedDataHandler: null,
      shouldRender: false,
      taskbarMode: 'floating', // 'floating' || 'static'
      socketData: {
        flow: {},
        users: [],
        usersData: {},
      },
      customTask: { actionType: null, task: {} },
      removeCustomTask: {},
      isLoading: false,
      isApplyingAISkillDraft: false,
      isPendingAISkillAutoSave: false,
    };
  },
  props: {
    processID: {
      type: String | undefined,
      required: true,
    },
    databases: {
      type: Array,
      required: true,
    },
  },
  methods: {
    normalizeAIWorkflowForApply(aiWorkflow = {}) {
      if (!aiWorkflow || !Array.isArray(aiWorkflow.tasks)) return null;

      const normalizedTasks = aiWorkflow.tasks.map((task, index) => {
        const hasValidShape =
          task?.shape &&
          typeof task.shape.x === 'number' &&
          typeof task.shape.y === 'number';

        return {
          ...task,
          caption: task?.caption || task?.name || `Task ${index + 1}`,
          shape: hasValidShape
            ? task.shape
            : {
                x: 420 + index * 210,
                y: 320,
              },
          input: Array.isArray(task?.input) ? task.input : [],
          output: Array.isArray(task?.output) ? task.output : [],
        };
      });

      return {
        ...this.process,
        ...aiWorkflow,
        id: this.process.id,
        name: aiWorkflow.caption || aiWorkflow.name || this.process.name,
        tasks: normalizedTasks,
      };
    },
    getPendingAISkillDraft() {
      const pendingDraftSources = [
        sessionStorage.getItem('aiSkillPendingDraft'),
        localStorage.getItem('aiSkillPendingDraft'),
      ];

      for (const raw of pendingDraftSources) {
        if (!raw) continue;
        try {
          const parsed = JSON.parse(raw);
          const isSameFlow =
            String(parsed?.flowId || '') === String(this.processID || '');
          const isFresh = Date.now() - Number(parsed?.ts || 0) < 1000 * 60 * 5;
          if (isSameFlow && isFresh) {
            return parsed;
          }
        } catch (error) {
          continue;
        }
      }
      return null;
    },
    async applyPendingAISkillDraftIfAny() {
      const pendingDraft = this.getPendingAISkillDraft();
      if (!pendingDraft?.workflow) return;

      const nextProcess = this.normalizeAIWorkflowForApply(pendingDraft.workflow);
      if (!nextProcess) return;

      this.isApplyingAISkillDraft = true;
      try {
        this.setProcess(nextProcess);
        this.setReferenceProcess();
        sessionStorage.removeItem('aiSkillPendingDraft');
        localStorage.removeItem('aiSkillPendingDraft');

        if (pendingDraft.action === 'save') {
          this.isPendingAISkillAutoSave = true;
        } else {
          this.showToaster(
            'Workflow-Entwurf wurde im Builder angewendet.',
            'Erfolgreich',
            'success'
          );
        }
      } finally {
        this.isApplyingAISkillDraft = false;
      }
    },
    checkTasksPostion() {
      if (this.process && this.process.tasks && this.process.tasks.length) {
        const data = [...this.process.tasks].map((el) => {
          const { x, y } = getValidatedTasksPosition(
            el.shape.x,
            el.shape.y,
            el.name
          );
          return { ...el, shape: { ...el.shape, x, y } };
        });

        this.process.tasks = [...data];
        this.referenceProcess = JSON.stringify(this.process);
      }
    },
    onTaskAdd(task) {
      const builderRef = this.$refs.WorkFlowBuilderRef;
      if (builderRef) {
        builderRef?.setActiveTask(task);
      }
    },
    async onSaveWorkflowFromAISkill() {
      const headerRef = this.$refs.WorkFlowHeaderRef;
      if (headerRef && typeof headerRef.saveFlow === 'function') {
        await headerRef.saveFlow();
        return true;
      }
      return false;
    },
    async saveAISkillDraftDirectly() {
      const res = await this.$store.dispatch('saveFlow', {
        flow: JSON.parse(JSON.stringify(this.process)),
      });
      if (!(res && typeof res === 'number')) {
        throw new Error(typeof res === 'string' ? res : 'Save failed');
      }
      this.setReferenceProcess();
      this.showToaster('Gespeichert !', 'Erfolgreich', 'success');
    },
    async runPendingAISkillAutoSaveIfAny() {
      if (!this.isPendingAISkillAutoSave) return;

      let isSaved = false;
      // Try a few ticks to wait for header mount.
      for (let i = 0; i < 6; i += 1) {
        await this.$nextTick();
        // eslint-disable-next-line no-await-in-loop
        isSaved = await this.onSaveWorkflowFromAISkill();
        if (isSaved) break;
      }

      if (!isSaved) {
        await this.saveAISkillDraftDirectly();
      }

      this.isPendingAISkillAutoSave = false;
    },
    saveZoomToLocalStorage() {
      const builderRef = this.$refs.WorkFlowBuilderRef;
      if (builderRef) {
        localStorage.setItem(
          `workFlowZoom-${this.user.username}`,
          builderRef?.zoom?.scale ? builderRef.zoom.scale : 1
        );
      }
    },
    async checkEditPermission(workFlowId) {
      try {
        const response = await getSharedWorkFlowUsers(workFlowId);
        if (response && response.status === 200) {
          this.flowPermission = response.data.find(
            (user) => user.identity == this.user.username
          );
          if (
            response.data.filter(
              (e) =>
                e.identity == this.user.username && e.access_level != 'execute'
            ).length > 0
          )
            return true;
          else {
            // If user has no access, redirect to process-list
            this.$router.push({
              path: 'process-list',
            });
          }
        }
      } catch (e) {
        this.$router.push({
          path: 'process-list',
        });
        throw new Error(e);
      }
    },
    async fetchData() {
      try {
        const response = await getWorkFlowById(this.processID);
        if (response && response.status === 200) {
          const { data } = response;

          if (!data.formTrigger) data.formTrigger = null;

          if (!data.settings.hasOwnProperty('btnCaption'))
            data.settings.btnCaption = 'Starten';
          if (!data.settings.hasOwnProperty('loadingCaption'))
            data.settings.loadingCaption = 'Ladevorgang läuft...';
          if (!data.settings.hasOwnProperty('fullWidth'))
            data.settings.fullWidth = false;
          if (!data.settings.hasOwnProperty('brandingColor'))
            data.settings.brandingColor = '#000';
          if (
            !data.settings.hasOwnProperty('isHtmlElementVisible') &&
            this.isAdmin
          )
            data.settings.isHtmlElementVisible = true;
          if (!data.settings.hasOwnProperty('workflowIcon')) {
            data.settings.workflowIcon = {
              icon: null,
              linkType: null,
            };
          }
          if (data.hasOwnProperty('tableID') && Array.isArray(data.tableID)) {
            data.tableID = data.tableID.filter(
              (databaseName) => databaseName.trim() != ''
            );
          }

          if (
            data?.tasks?.length >= 0 &&
            data?.tasks?.some((el) => el.name == 'CustomCode')
          ) {
            this.generateCustomTaskMiscObject('CustomCode');
          }
          this.process = data;
          this.referenceProcess = JSON.stringify(data);
          this.checkTasksPostion();

          if (this.process.owner != this.user.username) {
            await this.checkEditPermission(this.processID);
          } else {
            this.flowPermission = { access_level: workFlowAccessLevel.OWNER };
          }
        }
      } catch (error) {
        if (error.status === 400 && error.data?.message === 'Access denied.') {
          await this.$router.push({
            path: '/',
            query: {
              section: 'flows',
            },
          });
        }
        console.log('error====>', error);
        throw error;
      }
    },
    addMissingAttributesToFlow() {
      const startTaskIndex = this.process.tasks.findIndex(
        (el) => el.name === 'Start'
      );

      if (startTaskIndex > -1) {
        // Add structure to each element
        const formProps = this.isVueBasedFormBuilder
          ? this.process.tasks[startTaskIndex].props
          : this.process.tasks[startTaskIndex].props.formTrigger;
        for (let el of formProps.elements) {
          if (!el.hasOwnProperty('structure')) {
            el.structure = { tab: 0, row: 0, col: 0 };
          }
        }

        // Add structure to task
        if (!formProps.hasOwnProperty('structure')) {
          formProps.structure = {
            tabs: [
              {
                id: 0,
                rows: [
                  {
                    id: 0,
                    cols: [
                      {
                        id: 0,
                      },
                    ],
                  },
                ],
              },
            ],
          };
        }
      }
    },
    setRunFlowError(taskID) {
      this.runFlowError = taskID;
    },
    hideHtmlViewer() {
      this.htmlViewer = {
        isHtmlViewerVisible: false,
        html: null,
        json: null,
      };
    },
    setHtmlViewer(key, data) {
      this.htmlViewer[key] = data;
    },
    getDatabaseTask() {
      return this.process.tasks.find((task) => task.name === 'Database');
    },
    setLoader(bool) {
      this.loading = bool;
      this.shouldRender = !bool;
    },
    setProcess(process) {
      this.process = process;
    },
    setReferenceProcess() {
      this.referenceProcess = JSON.stringify(this.flowWithoutInputOutput);
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    async getDatabaseSchema(tableName) {
      try {
        const response = await getDataBaseTableSchema(tableName);

        if (response && response.status === 200 && response.data) {
          this.$store.commit('SET_DATABASE_SCHEMA', response.data);
          return response.data.data;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({ error });
        return null;
      }
    },
    async fetchAndAddSpecificCustomTask(id) {
      try {
        const response = await getCustomDatabaseItem(
          this.getCustomTaskDatabase[0].name,
          id
        );
        const customIcon =
          'https://res.cloudinary.com/gharnati-com/image/upload/v1681824477/noun-electricity-4806795_shvk5m.png';
        const customTask = generateTaskObject({
          name: 'CustomCode',
          customIcon: response.data.icon ? response.data.icon : customIcon,
          props: {
            ...response.data.code,
            description: response.data.description,
            name: response.data.taskname,
            inputs: response.data.inputfields,
            customTaskId: response.data.id,
          },
          id: 1,
          caption: response.data.taskname,
        });
        const taskIndex = this.customTasks.findIndex(
          (task) => task.props.customTaskId == id
        );
        if (taskIndex >= 0) {
          this.$set(this.customTasks, taskIndex, customTask);
        } else {
          this.customTasks.push(customTask);
        }
        this.generateCustomTaskMiscObject('CustomCode');
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    async addCustomTaskProcess() {
      if (this.getCustomTaskDatabase.length) {
        const databaseItems = await this.fetchAllCustomTask(
          this.getCustomTaskDatabase[0].name
        );

        if (databaseItems && databaseItems.length) {
          const customIcon =
            'https://res.cloudinary.com/gharnati-com/image/upload/v1681824477/noun-electricity-4806795_shvk5m.png';
          databaseItems.forEach((data, index) => {
            this.customTasks.push(
              generateTaskObject({
                name: 'CustomCode',
                customIcon: data.icon ? data.icon : customIcon,
                props: {
                  ...data.code,
                  description: data.description,
                  name: data.taskname,
                  inputs: data.inputfields,
                  customTaskId: data.id,
                  tasksize: data.tasksize,
                },
                id: index,
                caption: data.taskname,
              })
            );
          });
          this.generateCustomTaskMiscObject('CustomCode');
        }
      }
    },
    async fetchAllCustomTask(databaseName) {
      try {
        const response = await getCustomDatabaseItems(
          databaseName,
          '?keys=taskname,icon,description,code,inputfields,tasksize'
        );
        if (
          response.data &&
          response.data.items &&
          response.data.items.length > 0
        ) {
          return response.data.items.map((database) => {
            return { name: databaseName, ...database };
          });
        }
        return [];
      } catch (error) {
        console.log(error);
      }
    },
    generateCustomTaskMiscObject(taskName) {
      if (taskName == 'CustomCode') {
        this.$set(
          this.customMiscData,
          taskName,
          generateTaskMiskDataObject({
            isDroppable: true,
            isDeletable: true,
            isActive: true,
            icon: '',
            appearance: 'square',
            description: "this is testing description , we'll add more later",
            dropzones: ['before', 'after'],
            options: ['left', 'right'],
          })
        );
      }
    },
    setTaskbarMode(mode) {
      this.taskbarMode = mode;
    },
    onCloseTaskBar() {
      this.taskbarMode = 'floating';
    },
    initiateWorkFlow() {
      const startTask = this.workFlowTasks.find((el) => el.id === 1);
      if (startTask) {
        this.$refs.WorkFlowTaskBarRef.addTask(startTask, false);
      }
    },
    connectSocket() {
      try {
        const socket = io(process.env.VUE_APP_SOCKET_API, {
          auth: {
            type: 'workflow_users',
          },
        });
        const query = this.$route?.query;

        if (
          socket &&
          query &&
          query?.section &&
          query?.section !== 'process-designer'
        ) {
          return socket?.disconnect();
        }

        if (socket) {
          Vue.prototype.$socketInstance = socket;

          socket.on('connected', () => {
            socket.emit('workflow_user_join', {
              workflowId: this.processID,
              userId: this.user.username,
            });

            socket.on(
              `workflow_user_update_${this.processID}`,
              async (userJoinedData) => {
                if (userJoinedData) {
                  const data = JSON.parse(userJoinedData);
                  const { usersList, ...rest } = data;

                  await Promise.all(
                    usersList.map(async (el) => {
                      if (!this.socketData.usersData[el.id]) {
                        const res = await getUserDataByID(el.id, 'name');
                        if (res && res.status == 200 && res.data) {
                          this.socketData.usersData[el.id] = res.data;
                        }
                      }
                    })
                  );

                  this.socketData.flow = rest;
                  this.socketData.users = usersList;
                }
              }
            );

            socket.on(
              'workflow_user_active_check_' +
                this.processID +
                this.user.username,
              async (sessionTimeStamp) => {
                if (sessionTimeStamp != sessionStorage.getItem('sessionId')) {
                  socket.emit('workflow_user_join', {
                    workflowId: this.processID,
                    userId: this.user.username,
                  });
                }
              }
            );
          });
        }
      } catch (e) {
        console.log('socket connect error :', e);
      }
    },
    onSocketDisconnect(processId = null) {
      this.$socketInstance?.emit('workflow_user_leave', {
        workflowId:
          processId && typeof processId === 'string'
            ? processId
            : this.processID,
        userId: this.user.username,
        userLeaveTime: sessionStorage.getItem('sessionId') || '',
      });
      this.$socketInstance?.disconnect();
      delete Vue.prototype.$socketInstance;
      window.removeEventListener('unload', this.onSocketDisconnect);
      window.addEventListener('popstate', this.onSocketDisconnect);
    },
    showAccessDeniedToast() {
      this.showToaster(
        'Zugriff abgelehnt. Sie haben keine Berechtigung, auf diesen Flow zuzugreifen.',
        'Fehler',
        'danger'
      );
    },
    async getDatabaseTaskData() {
      if (this.process && this.process.tasks) {
        const databaseTask = this.getDatabaseTask();
        if (databaseTask && databaseTask?.props?.database) {
          try {
            const databaseSchema = JSON.parse(
              await this.getDatabaseSchema(databaseTask.props.database)
            );
            if (!databaseSchema) {
              throw new Error('unable to get database schema');
            }
            for (const key in databaseTask.props.item) {
              if (!databaseSchema.some((item) => item.name === key)) {
                delete databaseTask.props.item[key];
              }
            }
            if (
              databaseSchema?.length >
              Object.keys(databaseTask.props.item)?.length
            ) {
              this.showToaster(
                `Das Datenbankschema hat sich seit der letzten Anpassung verändert. Bitte öffnen Sie den Task ${databaseTask.caption} für mehr informationen`,
                'Hinweis',
                'warning'
              );
            }
          } catch (error) {
            this.showToaster(
              `Beim überprüfen des Datenbankschemas für den Task ${
                this.getDatabaseTask()?.caption
              } ist ein Fehler aufgetreten. Bitte prüfen Sie, ob die Datenbank vorhanden ist oder melden sich bei Ihrem Administrator.`,
              'Fehler',
              'danger'
            );
          }
        }
      }
    },

    async loadWorkflowData() {
      try {
        await this.fetchData();
        await this.addCustomTaskProcess();
        await this.getDatabaseTaskData();
        setTimeout(async () => {
          await this.addMissingAttributesToFlow();
        });
      } catch (error) {
        console.log('error===>', error);
        throw error;
      }
    },
    onCustomTaskActionTrigger(action, task) {
      this.onCloseTaskBar();
      this.customTask = { actionType: action, task };
      this.removeCustomTask = {
        id: task.props.customTaskId,
        name: task.props.customTaskId,
      };
    },
    closeCustomActionModal(isClose) {
      if (!isClose) return;
      this.customTask = { actionType: null, task: {} };
      this.removeCustomTask = {};
    },
    closeEditModal(isClose) {
      if (isClose) {
        const customTask = this.customTasks.find(
          (task) => task.props?.customTaskId === this.removeCustomTask.id
        );
        const previousCustomTask = this.customTask.task;
        if (customTask) {
          this.$set(customTask, 'caption', previousCustomTask.props.name);
          this.$set(customTask, 'customIcon', previousCustomTask.customIcon);
        }
      }
      this.closeCustomActionModal(true);
    },
    async confirmRemoveItem() {
      try {
        this.isLoading = true;
        const response = await deleteDatabaseItem(
          this.getCustomTaskDatabase[0].name,
          this.removeCustomTask.id
        );
        this.customTasks = this.customTasks.filter(
          (task) => task.props?.customTaskId !== this.removeCustomTask.id
        );
        this.showToaster(
          'Benutzerdefinierte Aufgabe erfolgreich gelöscht.',
          'Erfolgreich',
          'success'
        );
      } catch (err) {
        this.showToaster(
          `Beim Löschen ist ein Fehler aufgetreten. Versuchen Sie es erneut.`,
          'Fehlerhaft !',
          'danger'
        );
      } finally {
        this.isLoading = false;
        this.closeCustomActionModal(true);
      }
    },
  },
  async created() {
    try {
      this.setLoader(true);
      window.addEventListener(
        'beforeunload',
        (this.unsavedDataHandler = (event) => {
          if (this.hasUnsavedChanges) {
            return (event.returnValue =
              'Sie haben ungespeicherte Daten, wollen Sie die Seite wirklich verlassen?');
          }
        }),
        false
      );
      window.addEventListener('unload', this.onSocketDisconnect);
      window.addEventListener('popstate', this.onSocketDisconnect);

      await this.loadWorkflowData();
      await this.applyPendingAISkillDraftIfAny();

      this.setLoader(false);
      await this.runPendingAISkillAutoSaveIfAny();
      setTimeout(async () => {
        if (this.process) {
          this.connectSocket();
        }
      }, 0);
    } catch (error) {
      this.setLoader(false);
      if (error.status === 400 && error.data?.message === 'Access denied.') {
        this.showAccessDeniedToast();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.unsavedDataHandler, false);
    window.removeEventListener('unload', this.onSocketDisconnect);
    window.addEventListener('popstate', this.onSocketDisconnect);
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      isAdmin: 'getIsAdmin',
      user: 'getUser',
    }),
    getFlowAccessLevel() {
      return this.flowPermission.access_level;
    },
    isUserHasAccess() {
      return this.getFlowAccessLevel != workFlowAccessLevel.EDIT_CONTENT;
    },
    flowRunnerEndpoint() {
      if (
        this.isVueBasedFormBuilder &&
        this.process.settings.executionEndPoint != ''
      ) {
        return this.process.settings.executionEndPoint;
      } else if (
        this.process.settings.hasOwnProperty('apiEndpoint') &&
        this.process.settings.apiEndpoint != ''
      ) {
        return this.process.settings.apiEndpoint;
      } else return process.env.VUE_APP_FLOW_RUNNER_API;
    },
    flowWithoutInputOutput() {
      const flow = Object.assign({}, JSON.parse(JSON.stringify(this.process)));
      flow.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });
      return flow;
    },
    isTableIdArray() {
      if (typeof this.process.tableID === 'string') {
        return false;
      }

      if (Array.isArray(this.process.tableID)) {
        return true;
      }

      return null;
    },
    hasUnsavedChanges() {
      let flows = [
        JSON.parse(this.referenceProcess),
        JSON.parse(JSON.stringify(this.flowWithoutInputOutput)),
      ];

      // Remove irrelevant data for comparisation
      flows.forEach((f) => {
        f.tasks.forEach((t) => {
          delete t.shape.offsetx;
          delete t.shape.offsety;
          delete t.shape.selected;
        });
      });
      return JSON.stringify(flows[0]) != JSON.stringify(flows[1]);
    },
    getTasksArray() {
      return [...this.workFlowTasks, ...this.customTasks];
    },
    getTasksMiscData() {
      return { ...workFlowTasksMiscData, ...this.customMiscData };
    },
    getCustomTaskDatabase() {
      return this.databaseList.filter((ele) => ele.type == 'custom-task');
    },
    getWorkflowCustomTasks() {
      return workflowCustomTasksList;
    },
    isFlowEmpty() {
      return this.process.tasks.length === 0;
    },
    isFloatingTaskBar() {
      return this.taskbarMode === 'floating';
    },
    workFlowTasks() {
      return getWorkflowTasks(this.process?.version || 2);
    },

    isVueBasedFormBuilder() {
      return getIsVueBasedFormBuilder(this.process);
    },
  },
  watch: {
    async '$route.query'(newQueryParams, oldQueryParams) {
      if (newQueryParams['process'] !== oldQueryParams['process']) {
        try {
          this.setLoader(true);
          this.onSocketDisconnect(oldQueryParams['process']);
          await this.loadWorkflowData();
          await this.applyPendingAISkillDraftIfAny();
          await this.runPendingAISkillAutoSaveIfAny();
          setTimeout(() => {
            if (this.process) {
              this.connectSocket();
              window.addEventListener('unload', this.onSocketDisconnect);
              window.addEventListener('popstate', this.onSocketDisconnect);
            }
          }, 0);
        } catch (error) {
          await this.$router.push({
            path: '/',
            query: {
              section: 'flows',
            },
          });

          if (
            error.status === 400 &&
            error.data?.message === 'Access denied.'
          ) {
            this.showAccessDeniedToast();
          }
        } finally {
          this.setLoader(false);
        }
      }
    },
  },
  components: {
    WorkFlowHeader,
    WorkFlowTaskBar,
    WorkFlowBuilder,
    HtmlViewer,
    CustomModal,
    MakeCustomTaskComponent,
    RemoveConfirmModal,
  },
};
</script>
<style scoped>
*,
::before,
::after {
  box-sizing: border-box !important;
}

.workflow {
  color: #333343;
  background: #ffffff;
  /* height: 100%; */
  width: 100%;
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
}
.workflow .workflow-body {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  /* height: calc(100dvh - 88px); */
}

.workflow .workflow-loader {
  width: 100%;
  height: 100%;
  background: #fff;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1;
}

.workflow .workflow-loader .progress-icon {
  top: 50%;
  transform: translateY(-50%);
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: 0 auto;

  position: absolute;
}

.workflow .ai-skill-draft-loader {
  z-index: 4;
  background: rgba(255, 255, 255, 0.88);
}

.workflow .ai-skill-draft-loader .loader-caption {
  position: absolute;
  top: calc(50% + 50px);
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #111;
}

.workflow .workflow-loader .progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #000000;
  border-color: #000000 transparent #000000 transparent;
  animation: progress-icon 1.2s linear infinite;
}

.workflow .workflow-taskbar-wrapper {
  position: relative;
  height: 100%;
  width: 358px;
  flex-shrink: 0;
  transition: width 0.3s ease;
}

.workflow .empty-workflow-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.workflow .empty-workflow-container .init-task-add-button {
  text-align: center;
  font-weight: 100;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 5px;
  border-radius: 50%;
  font-size: 40px;
  transition: 0.2s ease-in-out all;
  height: 58px;
  width: 58px;
  border: 0.5px solid #000;
  background-color: #000;
}

.workflow .empty-workflow-container .init-task-add-button svg path {
  stroke: #fff;
}
.workflow .empty-workflow-container .init-task-add-button:hover {
  color: #fff;
  border-color: #b3b3b3;
  background-color: transparent;
}

.workflow .empty-workflow-container .init-task-add-button:hover svg path {
  stroke: #b3b3b3;
}

.workflow .custom-action-modal ::v-deep .custom-task-edit-component {
  z-index: 1;
  height: calc(100% - 150px);
  margin-top: 105px;
}
.workflow .custom-action-modal ::v-deep .custom-modal {
  width: 100%;
  height: 100%;
}
.workflow .custom-action-modal h1 {
  font-weight: 500;
  font-size: 30px;
  line-height: 36px;
  color: #333343;
  text-align: center;
  margin: 0;
  margin-top: 30px;
  z-index: 99;
  position: relative;
}
</style>
